<template>
  <main class="search-hotel">
    <Header />
    <section class="template-header d-flex justify-center align-center text-center">
      <div class="shadow"></div>
      <div class="item">
        <h1
          class="font-weight-regular text-uppercase px-4"
        >{{ $vuetify.lang.t('$vuetify.serch-hotel.template-header.title') }}</h1>
      </div>
    </section>
    <section class="template pt-6 pb">
      <v-container>
        <v-row>
          <v-col class="text-center">
            <h1>{{ $vuetify.lang.t('$vuetify.serch-hotel.template.title') }}</h1>
          </v-col>
        </v-row>
        <v-row class="pt-6" :class="{hide: this.$vuetify.lang.current !== 'ru'}">
          <v-col>
            <div id="hotel"></div>
          </v-col>
        </v-row>
        <v-row class="pt-6" :class="{hide: this.$vuetify.lang.current === 'ru'}">
          <v-col>
            <div id="hotelEnglish"></div>
          </v-col>
        </v-row>
      </v-container>
    </section>
    <Footer />
  </main>
</template>

<script>
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
export default {
  components: {
    Header,
    Footer
  },
  mounted() {
    const hotel = document.createElement("script");
    hotel.setAttribute(
      "src",
      "https://cpa.ostrovok.ru/static/widget/scripts/713dceca109f6eb3196b14764d6a3df8.js"
    );
    const hotelEnglish = document.createElement("script");
    hotelEnglish.setAttribute(
      "src",
      "https://cpa.ostrovok.ru/static/widget/scripts/e714ea59a10667f5869a521519ce0be1.js"
    );

    document.querySelector("#hotel").appendChild(hotel);
    document.querySelector("#hotelEnglish").appendChild(hotelEnglish);
  }
};
</script>

<style lang="scss">
#app {
  .search-hotel {
    height: 100%;
    .hide {
      display: none;
    }
    .template-header {
      background: url("../assets/background.jpg") center center / cover;
      .shadow {
        opacity: 1;
      }
    }
    .template {
      .ostrovok-div {
        .zen-tabs-body {
          border: none !important;
        }
        .ost-img-blue {
          content: url("https://cpa.ostrovok.ru/static/widget/img/ost_white.png") !important;
        }
        .zen-logo-text {
          position: absolute !important;
          right: 6%;
          font-size: 1rem !important;
          color: #fff !important;
        }
      }
    }
  }
}
</style>